import { Box } from '@mui/material';
import PepperLogo from './svg/PepperLogo';

let customerLogos = [
  {
    logo: "customer-logos/yum.png", 
    width: { xs: 50, sm: 50, md: 50 },
    name: "Yum"
  },
  {
    logo: "customer-logos/lyft.png", 
    width: { xs: 50, sm: 50, md: 50 },
    name: "Lyft"
  },
  {
    logo: "customer-logos/wasserman.png", 
    width: { xs: 90, sm: 120, md: 130 },
    name: "Wasserman"
  },
  {
    logo: "customer-logos/microsoft.png", 
    width: { xs: 90, sm: 100, md: 110 },
    name: "Microsoft"
  },
  {
    logo: "customer-logos/mckinney.png", 
    width: { xs: 80, sm: 100, md: 110 },
    name: "McKinney"
  },
  {
    logo: "customer-logos/hyundai.png", 
    width: { xs: 60, sm: 65, md: 60 },
    name: "Hyundai"
  },
  {
    logo: "customer-logos/samsung.png", 
    width: { xs: 70, sm: 100, md: 100 },
    name: "Samsung"
  }, 
]

const TrustedBy = () => {
  return (
    <Box
      sx={{
        maxWidth: '1200px',
        mx: 'auto',
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          display: { xs: 'block', sm: 'flex' },
          flexWrap: { sm: 'wrap' },
          justifyContent: { sm: 'center' },
          alignItems: { sm: 'center' },
          gap: { sm: 3, md: 6 },
          py: { xs: 2, md: 3 },
        }}
      >
        {/* Mobile pyramid layout */}
        <Box
          sx={{
            display: { xs: 'block', sm: 'none' },
          }}
        >
          {/* Top row - 4 logos */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 3,
              mb: 3,
            }}
          >
            {customerLogos.slice(0, 4).map((logo, index) => (
              <Box
                key={index}
                component="img"
                src={logo.logo}
                alt={logo.name}
                sx={{
                  width: logo.width,
                  height: 'auto',
                  transition: 'opacity 0.2s, transform 0.2s, filter 0.2s',
                  // filter: 'grayscale(100%) opacity(0.7)',
                  '&:hover': {
                    filter: 'grayscale(0%) opacity(1)',
                    transform: 'scale(1.05)'
                  }
                }}
              />
            ))}
          </Box>
          
          {/* Bottom row - 3 logos centered */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 3,
            }}
          >
            {customerLogos.slice(4, 7).map((logo, index) => (
              <Box
                key={index + 4}
                component="img"
                src={logo.logo}
                alt={logo.name}
                sx={{
                  width: logo.width,
                  height: 'auto',
                  transition: 'opacity 0.2s, transform 0.2s, filter 0.2s',
                  // filter: 'grayscale(100%) opacity(0.7)',
                  '&:hover': {
                    filter: 'grayscale(0%) opacity(1)',
                    transform: 'scale(1.05)'
                  }
                }}
              />
            ))}
          </Box>
        </Box>

        {/* Tablet and desktop layout */}
        <Box
          sx={{
            display: { xs: 'none', sm: 'contents' },
          }}
        >
          {customerLogos.map((logo, index) => (
            <Box
              key={index}
              component="img"
              src={logo.logo}
              alt={logo.name}
              sx={{
                width: logo.width,
                height: 'auto',
                transition: 'opacity 0.2s, transform 0.2s, filter 0.2s',
                // filter: 'grayscale(100%) opacity(0.7)',
                '&:hover': {
                  filter: 'grayscale(0%) opacity(1)',
                  transform: 'scale(1.05)'
                }
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default TrustedBy; 